import React from 'react'
import classNames from 'classnames'
import styles from '../styles.css'

type PropsType = {
  setActiveRowIndex: (num: number) => void
  colors: any
  executeAction: (entry: any, cmdPressed: boolean) => void
  entry: any
  active: boolean
  index: number
  previewMode?: boolean
}

export const SearchResultRow = (props: PropsType) => {
  var active = props.active
  var setActiveRowIndex = props.setActiveRowIndex
  var executeAction = props.executeAction
  const index = props.index

  const { name, link, logo, actionTitle, cta } = props.entry

  const fieldRef = React.useRef<HTMLInputElement>(null)

  React.useEffect(() => {
    if (active && fieldRef.current) {
      fieldRef.current.scrollIntoView()
    }
  }, [active])

  if (link) {
    return (
      <div
        className={classNames(
          styles.searchResult,
          active ? styles.active : styles.inactive
        )}
        style={{
          color: props.colors?.text ? props.colors.text : '#333',
          backgroundColor: active
            ? props.colors?.secondary
              ? props.colors.secondary
              : '#f4f4f4'
            : props.colors?.primary
            ? props.colors.primary
            : 'white'
        }}
        ref={fieldRef}
        onClick={() => {
          setActiveRowIndex(index)
          executeAction(props.entry, false)
        }}
        onMouseEnter={() => setActiveRowIndex(index)}
      >
        <img
          style={{
            height: 24,
            width: 24,
            objectFit: 'fill',
            borderRadius: 4
          }}
          src={logo}
        />
        <b style={{ marginTop: 4, marginLeft: 8 }}>{name}</b>
        <span
          style={{
            marginTop: 4,
            marginLeft: 12,
            color: props.colors?.subtext ? props.colors.subtext : '#888'
          }}
        >
          {cta || 'Open link'} →
        </span>
      </div>
    )
  } else {
    return (
      <div
        className={classNames(
          styles.searchResult,
          active ? styles.active : styles.inactive
        )}
        style={{
          color: props.colors?.text ? props.colors.text : '#333',
          backgroundColor: active
            ? props.colors?.secondary
              ? props.colors.secondary
              : '#f4f4f4'
            : props.colors?.primary
            ? props.colors.primary
            : 'white'
        }}
        ref={fieldRef}
        onClick={() => {
          setActiveRowIndex(index)
          executeAction(props.entry, false)
        }}
        onMouseEnter={() => setActiveRowIndex(index)}
      >
        <img
          style={{
            height: 24,
            width: 24,
            objectFit: 'fill',
            borderRadius: 4
          }}
          src={logo}
        />
        <b
          style={{
            marginTop: 4,
            marginLeft: 8,
            color: props.colors?.text ? props.colors.text : '#888'
          }}
        >
          {name}
        </b>
        <span
          style={{
            marginTop: 4,
            marginLeft: 12,
            color: props.colors?.subtext ? props.colors.subtext : '#888'
          }}
        >
          {cta || actionTitle} →
        </span>
      </div>
    )
  }
}
